(function (ng) {
    

    angular.module('harmonica', ['dom']);
})(angular);
